export class GoToEmailTabEvent {}
